export enum ReferralCancelReasonKey {
  cost = 'cost',
  no_response = 'no_response',
  incorrect_details = 'incorrect_details',
  seen_elsewhere = 'seen_elsewhere',
  no_wish_to_proceed = 'no_wish_to_proceed',
  referral_out_of_scope = 'referral_out_of_scope',
  patient_declined_consent = 'patient_declined_consent',
  patient_no_answer = 'patient_no_answer',
}
